import { BOOKMARKS_MODAL } from './BookmarksConstants';

export const getBookmarksModalId = id =>
  id ? `${BOOKMARKS_MODAL}-${id}` : BOOKMARKS_MODAL;



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/PF4/Bookmarks/BookmarksHelpers.js